/**
 * @fileoverview gRPC-Web generated client stub for reportpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../../google/type/date_pb.js')
const proto = {};
proto.reportpb = require('./clientsummary_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.ClientSummaryServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.ClientSummaryServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListClientSummaryRequest,
 *   !proto.reportpb.ListClientSummaryResponse>}
 */
const methodDescriptor_ClientSummaryService_ListClientSummary = new grpc.web.MethodDescriptor(
  '/reportpb.ClientSummaryService/ListClientSummary',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListClientSummaryRequest,
  proto.reportpb.ListClientSummaryResponse,
  /**
   * @param {!proto.reportpb.ListClientSummaryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListClientSummaryResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.ListClientSummaryRequest,
 *   !proto.reportpb.ListClientSummaryResponse>}
 */
const methodInfo_ClientSummaryService_ListClientSummary = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.ListClientSummaryResponse,
  /**
   * @param {!proto.reportpb.ListClientSummaryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListClientSummaryResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListClientSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.ListClientSummaryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListClientSummaryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ClientSummaryServiceClient.prototype.listClientSummary =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ClientSummaryService/ListClientSummary',
      request,
      metadata || {},
      methodDescriptor_ClientSummaryService_ListClientSummary,
      callback);
};


/**
 * @param {!proto.reportpb.ListClientSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListClientSummaryResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.ClientSummaryServicePromiseClient.prototype.listClientSummary =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ClientSummaryService/ListClientSummary',
      request,
      metadata || {},
      methodDescriptor_ClientSummaryService_ListClientSummary);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListMarginRequirementDetailsRequest,
 *   !proto.reportpb.ListMarginRequirementDetailsResponse>}
 */
const methodDescriptor_ClientSummaryService_ListMarginRequirementDetails = new grpc.web.MethodDescriptor(
  '/reportpb.ClientSummaryService/ListMarginRequirementDetails',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListMarginRequirementDetailsRequest,
  proto.reportpb.ListMarginRequirementDetailsResponse,
  /**
   * @param {!proto.reportpb.ListMarginRequirementDetailsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListMarginRequirementDetailsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.ListMarginRequirementDetailsRequest,
 *   !proto.reportpb.ListMarginRequirementDetailsResponse>}
 */
const methodInfo_ClientSummaryService_ListMarginRequirementDetails = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.ListMarginRequirementDetailsResponse,
  /**
   * @param {!proto.reportpb.ListMarginRequirementDetailsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListMarginRequirementDetailsResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListMarginRequirementDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.ListMarginRequirementDetailsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListMarginRequirementDetailsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ClientSummaryServiceClient.prototype.listMarginRequirementDetails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ClientSummaryService/ListMarginRequirementDetails',
      request,
      metadata || {},
      methodDescriptor_ClientSummaryService_ListMarginRequirementDetails,
      callback);
};


/**
 * @param {!proto.reportpb.ListMarginRequirementDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListMarginRequirementDetailsResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.ClientSummaryServicePromiseClient.prototype.listMarginRequirementDetails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ClientSummaryService/ListMarginRequirementDetails',
      request,
      metadata || {},
      methodDescriptor_ClientSummaryService_ListMarginRequirementDetails);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListSegregationDetailsRequest,
 *   !proto.reportpb.ListSegregationDetailsResponse>}
 */
const methodDescriptor_ClientSummaryService_ListSegregationDetails = new grpc.web.MethodDescriptor(
  '/reportpb.ClientSummaryService/ListSegregationDetails',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListSegregationDetailsRequest,
  proto.reportpb.ListSegregationDetailsResponse,
  /**
   * @param {!proto.reportpb.ListSegregationDetailsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListSegregationDetailsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.ListSegregationDetailsRequest,
 *   !proto.reportpb.ListSegregationDetailsResponse>}
 */
const methodInfo_ClientSummaryService_ListSegregationDetails = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.ListSegregationDetailsResponse,
  /**
   * @param {!proto.reportpb.ListSegregationDetailsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListSegregationDetailsResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListSegregationDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.ListSegregationDetailsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListSegregationDetailsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ClientSummaryServiceClient.prototype.listSegregationDetails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ClientSummaryService/ListSegregationDetails',
      request,
      metadata || {},
      methodDescriptor_ClientSummaryService_ListSegregationDetails,
      callback);
};


/**
 * @param {!proto.reportpb.ListSegregationDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListSegregationDetailsResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.ClientSummaryServicePromiseClient.prototype.listSegregationDetails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ClientSummaryService/ListSegregationDetails',
      request,
      metadata || {},
      methodDescriptor_ClientSummaryService_ListSegregationDetails);
};


module.exports = proto.reportpb;

